import React from "react";
import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: var(--bgColorFrontend);
`;

const Spinner = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -35px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    padding: 3px;
    background: conic-gradient(
      from 0deg,
      var(--brandColor),
      var(--brandColorFrontend),
      var(--hoverButtonColor),
      var(--brandColor)
    );
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    animation: ${rotate} 1.3s linear infinite;
  }
`;

const Glow = styled.div`
  position: absolute;
  width: 115px;
  height: 115px;
  border-radius: 50%;
  box-shadow: 0 0 30px var(--brandColorFrontend);
  filter: blur(5px);
  z-index: 0;
  opacity: 0.6;
`;

const Logo = styled.img`
  width: 90px;
  height: 90px;
  object-fit: contain;
  z-index: 1;
  user-select: none;
  pointer-events: none;
`;

export default function LazyLoading() {
  return (
    <Wrapper>
      <Spinner>
        <Glow />
        <Logo src="/zodot-logo.png" alt="Website Logo" />
      </Spinner>
    </Wrapper>
  );
}
